/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import SnackbarStore from '../store/SnackbarStore'
import SnackbarView from '../view/SnackbarView'

class SnackbarContainer extends Component {
  static getStores() {
    return [SnackbarStore]
  }

  static calculateState(prevState, props) {
    return {
      snackbar: SnackbarStore.getState()
    }
  }

  render() {
    return SnackbarView(this.state)
  }
}

export default Container.create(SnackbarContainer)
